import axios from 'axios';

// Dedicated axios instance for Technical Operations endpoints.
const techopsApi = axios.create({ baseURL: '/api/techops', withCredentials: true });

techopsApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

techopsApi.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      const onLogin = window.location.pathname === '/login';
      if (!onLogin) {
        localStorage.removeItem('flowup_token');
        window.dispatchEvent(new CustomEvent('auth:logout'));
        setTimeout(() => { window.location.replace('/login'); }, 100);
      }
    }
    return Promise.reject(err.response?.data || { error: err.message });
  }
);

techopsApi.get = (url, config) => techopsApi({ method: 'get', url, ...config });
techopsApi.post = (url, data, config) => techopsApi({ method: 'post', url, data, ...config });
techopsApi.put = (url, data, config) => techopsApi({ method: 'put', url, data, ...config });
techopsApi.delete = (url, config) => techopsApi({ method: 'delete', url, ...config });

export const CR_STATUS = {
  draft: { label: 'Draft', color: '#6B7280', bg: 'rgba(107,114,128,0.12)' },
  pending_approval: { label: 'Pending Approval', color: '#B45309', bg: 'rgba(180,83,9,0.12)' },
  approved: { label: 'Approved', color: '#2563EB', bg: 'rgba(37,99,235,0.12)' },
  completed: { label: 'Completed', color: '#16A34A', bg: 'rgba(22,163,74,0.12)' },
  rejected: { label: 'Rejected', color: '#DC2626', bg: 'rgba(220,38,38,0.12)' },
};

export const INC_STATUS = {
  draft: { label: 'Draft', color: '#6B7280', bg: 'rgba(107,114,128,0.12)' },
  published: { label: 'Notified', color: '#16A34A', bg: 'rgba(22,163,74,0.12)' },
};

export default techopsApi;
